export default "__VITE_ASSET__btW$pao5__"